import React from 'react';
import { Link } from 'react-router-dom';
import { Eyebrow } from './Eyebrow';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#404040] text-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-16 md:gap-8">
          {/* Brand */}
          <div>
            <h2 className="font-display text-2xl tracking-wide mb-3 text-[#EFE8D8]">Lot 20</h2>
            <p className="text-[#919191] text-sm leading-relaxed max-w-xs">
              Experimental Kenyan specialty coffee. From our soil to your roastery.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <Eyebrow tone="footer" className="mb-5">Navigate</Eyebrow>
            <div className="space-y-3">
              {[
                { to: '/coffees', label: 'Coffees' },
                { to: '/sample-pack', label: 'Samples' },
                { to: '/about', label: 'About' },
                { to: '/contact', label: 'Contact' },
              ].map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm text-[#B9B9B9] hover:text-[#EFE8D8] transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <Eyebrow tone="footer" className="mb-5">Contact</Eyebrow>
            <div className="space-y-3">
              <a href="mailto:sidney@lot20.coffee" className="block text-sm text-[#B9B9B9] hover:text-[#EFE8D8] transition-colors duration-300">
                sidney@lot20.coffee
              </a>
              <p className="text-sm text-[#919191]">
                Western Highlands, Kenya
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#919191]">
            &copy; {new Date().getFullYear()} Lot 20 Coffee Farmers Services Ltd.
          </p>
          <p className="flex items-center gap-3 text-xs text-[#919191]">
            <span>All rights reserved.</span>
            <span className="text-white/15">&middot;</span>
            <Link to="/portal/login" className="hover:text-[#EFE8D8] transition-colors duration-300">
              Buyer Portal
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
